// Product commerce mock layer — online orders + product sales for the Products
// V2 Sales and Orders tabs. MOCK-FIRST: orders are seeded once and persisted to
// localStorage so fulfilment changes (packed/shipped/...) stick during a demo.
//
// TODO(backend): swap for real endpoints — list/get orders, update fulfilment
// status, add tracking, refund, cancel; and a product-sales report (online +
// in-salon POS). See PRODUCT-V2-SCOPE.md sections 5 and 9.

const ORDERS_KEY = 'beu_product_orders_mock_v2';

// Fulfilment status model. `next` lists the allowed forward transitions used to
// render the primary action button on the order.
export const FULFILMENT = {
  unfulfilled:          { label: 'Unfulfilled',          tone: 'amber',  next: ['packed'] },
  packed:               { label: 'Packed',               tone: 'blue',   next: ['shipped'] },
  shipped:              { label: 'Shipped',              tone: 'violet', next: ['delivered'] },
  delivered:            { label: 'Delivered',            tone: 'green',  next: [] },
  ready_for_collection: { label: 'Ready for collection', tone: 'blue',   next: ['collected'] },
  collected:            { label: 'Collected',            tone: 'green',  next: [] },
  cancelled:            { label: 'Cancelled',            tone: 'grey',   next: [] },
};

export const PAYMENT_TONE = { paid: 'green', refunded: 'grey', partially_refunded: 'amber', pending: 'amber' };

const ts = (daysAgo, h = 10, m = 0) => {
  // Deterministic timestamps relative to a fixed reference (no Date.now in
  // mock seeds so the demo is stable). Reference: 2026-06-05.
  const base = new Date('2026-06-05T00:00:00Z').getTime();
  return new Date(base - daysAgo * 86400000 + (h * 60 + m) * 60000).toISOString();
};

const SEED = [
  {
    id: 'o1', number: 'BEU-1042', createdAt: ts(0, 9, 12), channel: 'online',
    customer: { name: 'Hannah Brooks', email: 'hannah.brooks@gmail.com', phone: '+44 7700 900112' },
    delivery: { method: 'ship', address: { line1: '14 Mill Lane', city: 'Bristol', postcode: 'BS1 4QA', country: 'United Kingdom' } },
    items: [
      { productId: 'p1', name: 'Repair Shampoo 250ml', qty: 1, qtyFulfilled: 0, unitPrice: 22 },
      { productId: 'p2', name: 'Bond Treatment Mask', qty: 1, qtyFulfilled: 0, unitPrice: 34 },
    ],
    subtotal: 56, shipping: 4.95, tax: 0, discount: 0, total: 60.95,
    paymentStatus: 'paid', fulfilmentStatus: 'unfulfilled', tracking: null,
    customerNote: 'Please leave with a neighbour if out.', internalNote: '',
    timeline: [{ at: ts(0, 9, 12), label: 'Order placed and paid' }],
  },
  {
    id: 'o2', number: 'BEU-1041', createdAt: ts(0, 8, 40), channel: 'online',
    customer: { name: 'Marcus Webb', email: 'm.webb@outlook.com', phone: '+44 7700 900337' },
    delivery: { method: 'collect', address: null, instructions: 'Collect from reception' },
    items: [{ productId: 'p3', name: 'Sea Salt Texture Spray', qty: 2, qtyFulfilled: 2, unitPrice: 18 }],
    subtotal: 36, shipping: 0, tax: 0, discount: 0, total: 36,
    paymentStatus: 'paid', fulfilmentStatus: 'ready_for_collection', tracking: null,
    customerNote: '', internalNote: '',
    timeline: [{ at: ts(0, 8, 40), label: 'Order placed and paid' }, { at: ts(0, 9, 30), label: 'Ready for collection' }],
  },
  {
    id: 'o3', number: 'BEU-1040', createdAt: ts(1, 16, 5), channel: 'online',
    customer: { name: 'Priya Shah', email: 'priya.shah@gmail.com', phone: '+44 7700 900551' },
    delivery: { method: 'ship', address: { line1: '8 Elmwood Court', city: 'Leeds', postcode: 'LS2 9JT', country: 'United Kingdom' } },
    items: [
      { productId: 'p4', name: 'Argan Hair Oil 100ml', qty: 1, qtyFulfilled: 1, unitPrice: 28 },
      { productId: 'p5', name: 'Wide-tooth Comb', qty: 1, qtyFulfilled: 1, unitPrice: 9 },
    ],
    subtotal: 37, shipping: 4.95, tax: 0, discount: 5, total: 36.95,
    paymentStatus: 'paid', fulfilmentStatus: 'packed', tracking: null,
    customerNote: '', internalNote: 'Discount: returning customer',
    timeline: [
      { at: ts(1, 16, 5), label: 'Order placed and paid' },
      { at: ts(0, 11, 30), label: 'Packed' },
    ],
  },
  {
    id: 'o4', number: 'BEU-1039', createdAt: ts(2, 12, 22), channel: 'online',
    customer: { name: 'Daniel Okafor', email: 'd.okafor@gmail.com', phone: '+44 7700 900773' },
    delivery: { method: 'ship', address: { line1: '22 Frith Street', city: 'London', postcode: 'W1D 4RP', country: 'United Kingdom' } },
    items: [{ productId: 'p1', name: 'Repair Shampoo 250ml', qty: 1, qtyFulfilled: 1, unitPrice: 22 }],
    subtotal: 22, shipping: 4.95, tax: 0, discount: 0, total: 26.95,
    paymentStatus: 'paid', fulfilmentStatus: 'shipped',
    tracking: { courier: 'Royal Mail', number: 'AB123456789GB', url: 'https://www.royalmail.com/track-your-item' },
    customerNote: '', internalNote: '',
    timeline: [
      { at: ts(2, 12, 22), label: 'Order placed and paid' },
      { at: ts(1, 10, 0), label: 'Packed' },
      { at: ts(1, 15, 40), label: 'Shipped via Royal Mail · AB123456789GB' },
    ],
  },
  {
    id: 'o5', number: 'BEU-1037', createdAt: ts(5, 10, 0), channel: 'online',
    customer: { name: 'Sophie Allen', email: 'sophie.a@gmail.com', phone: '+44 7700 900998' },
    delivery: { method: 'ship', address: { line1: '5 Harbour View', city: 'Brighton', postcode: 'BN1 1AE', country: 'United Kingdom' } },
    items: [{ productId: 'p2', name: 'Bond Treatment Mask', qty: 1, qtyFulfilled: 1, unitPrice: 34 }],
    subtotal: 34, shipping: 4.95, tax: 0, discount: 0, total: 38.95,
    paymentStatus: 'paid', fulfilmentStatus: 'delivered',
    tracking: { courier: 'DPD', number: 'DPD9981234455', url: 'https://track.dpd.co.uk' },
    customerNote: '', internalNote: '',
    timeline: [
      { at: ts(5, 10, 0), label: 'Order placed and paid' },
      { at: ts(4, 11, 0), label: 'Packed' },
      { at: ts(4, 16, 0), label: 'Shipped via DPD · DPD9981234455' },
      { at: ts(3, 9, 30), label: 'Delivered' },
    ],
  },
  {
    id: 'o6', number: 'BEU-1036', createdAt: ts(6, 14, 0), channel: 'online',
    customer: { name: 'Aisha Khan', email: 'aisha.k@gmail.com', phone: '+44 7700 900221' },
    delivery: { method: 'collect', address: null, instructions: 'Collect from reception' },
    items: [{ productId: 'p2', name: 'Bond Treatment Mask', qty: 1, qtyFulfilled: 1, unitPrice: 34 }],
    subtotal: 34, shipping: 0, tax: 0, discount: 0, total: 34,
    paymentStatus: 'paid', fulfilmentStatus: 'collected', tracking: null,
    customerNote: '', internalNote: '',
    timeline: [
      { at: ts(6, 14, 0), label: 'Order placed and paid' },
      { at: ts(6, 15, 0), label: 'Ready for collection' },
      { at: ts(5, 11, 0), label: 'Collected' },
    ],
  },
  {
    id: 'o7', number: 'BEU-1035', createdAt: ts(7, 9, 30), channel: 'online',
    customer: { name: 'Tom Reilly', email: 't.reilly@outlook.com', phone: '+44 7700 900118' },
    delivery: { method: 'ship', address: { line1: '3 Castle Road', city: 'Cardiff', postcode: 'CF10 1BH', country: 'United Kingdom' } },
    items: [{ productId: 'p6', name: 'Heat Protect Spray', qty: 1, qtyFulfilled: 0, unitPrice: 20 }],
    subtotal: 20, shipping: 3.95, tax: 0, discount: 0, total: 23.95,
    paymentStatus: 'refunded', fulfilmentStatus: 'cancelled', tracking: null,
    customerNote: '', internalNote: 'Customer changed their mind before dispatch.',
    timeline: [
      { at: ts(7, 9, 30), label: 'Order placed and paid' },
      { at: ts(7, 12, 0), label: 'Order cancelled' },
      { at: ts(7, 12, 5), label: 'Refunded £23.95' },
    ],
  },
];

const safeParse = (raw) => { try { return JSON.parse(raw); } catch (e) { return null; } };

// Sample orders are for demos only. A real account, new or old, starts with an
// empty Orders tab: seeding here put a fake "1 unfulfilled" badge on every
// salon's Products page. Turn the sample data on with ?demoOrders=1 (off with
// ?demoOrders=0) in dev, staging and beta; never in production.
const DEMO_KEY = 'beu_product_orders_demo';
const SEED_IDS = new Set(SEED.map((o) => o.id));
const demoAllowed = () => !['prod', 'production', 'rush', 'rush_prod'].includes(String(process.env.REACT_APP_ENV || '').toLowerCase());
export const demoOrdersEnabled = () => {
  if (!demoAllowed() || typeof window === 'undefined') return false;
  try {
    const q = new URLSearchParams(window.location.search).get('demoOrders');
    if (q === '1') localStorage.setItem(DEMO_KEY, '1');
    if (q === '0') localStorage.removeItem(DEMO_KEY);
    return localStorage.getItem(DEMO_KEY) === '1';
  } catch (e) { return false; }
};

export const getOrders = () => {
  const stored = safeParse(typeof localStorage !== 'undefined' && localStorage.getItem(ORDERS_KEY));
  const demo = demoOrdersEnabled();
  if (Array.isArray(stored)) {
    if (demo) return stored;
    // Drop sample rows left over from before the seed was gated; keep anything
    // the mock storefront loop created in this browser.
    const real = stored.filter((o) => !SEED_IDS.has(o.id));
    if (real.length !== stored.length) {
      try { if (real.length) localStorage.setItem(ORDERS_KEY, JSON.stringify(real)); else localStorage.removeItem(ORDERS_KEY); } catch (e) { /* ignore */ }
    }
    return real;
  }
  if (!demo) return [];
  try { localStorage.setItem(ORDERS_KEY, JSON.stringify(SEED)); } catch (e) { /* ignore */ }
  return SEED.map((o) => ({ ...o }));
};

const saveOrders = (orders) => {
  try { localStorage.setItem(ORDERS_KEY, JSON.stringify(orders)); } catch (e) { /* ignore */ }
  return orders;
};

// Apply a fulfilment change to one order and persist. `extra` can carry tracking
// and a timeline label. Returns the updated orders array.
export const updateOrder = (orders, id, patch, timelineLabel, when) => {
  const next = orders.map((o) => {
    if (o.id !== id) return o;
    const updated = { ...o, ...patch };
    if (timelineLabel) {
      updated.timeline = [...(o.timeline || []), { at: when || ts(0, 12, 0), label: timelineLabel }];
    }
    // Keep item fulfilment in sync with the order status — fulfilled once prepared,
    // un-fulfilled if the order is moved back to unfulfilled. This makes status
    // changes reversible.
    if (patch.fulfilmentStatus) {
      if (['packed', 'shipped', 'delivered', 'collected', 'ready_for_collection'].includes(patch.fulfilmentStatus)) {
        updated.items = (o.items || []).map((it) => ({ ...it, qtyFulfilled: it.qty }));
      } else if (patch.fulfilmentStatus === 'unfulfilled') {
        updated.items = (o.items || []).map((it) => ({ ...it, qtyFulfilled: 0 }));
      }
    }
    return updated;
  });
  return saveOrders(next);
};

export const resetOrders = () => { try { localStorage.removeItem(ORDERS_KEY); } catch (e) { /* ignore */ } };

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Create a new online order from a customer storefront checkout and persist it
// to the SAME store the admin Orders tab reads — so a customer purchase shows
// up in Catalogue -> Products -> Orders in the same browser (mock demo loop).
// `input`: { lines:[{id,name,qty,price}], subtotal, shipping, total, method:'ship'|'collect',
//   customer:{name,email,phone}, address?, note }. Returns the created order.
// TODO(backend): real product checkout creates this order server-side alongside
// a real payment (mirror the gift-card payment link).
export const addOrder = (input) => {
  const orders = getOrders();
  const maxNum = orders.reduce((m, o) => {
    const n = parseInt(String(o.number || '').replace(/\D/g, ''), 10);
    return Number.isFinite(n) && n > m ? n : m;
  }, 1042);
  const num = maxNum + 1;
  const nowIso = new Date().toISOString();
  const items = (input.lines || []).map((l) => ({ productId: l.id, name: l.name, qty: l.qty, qtyFulfilled: 0, unitPrice: l.price }));
  const order = {
    id: `o-${num}`,
    number: `BEU-${num}`,
    createdAt: nowIso,
    channel: 'online',
    customer: { name: input.customer.name, email: input.customer.email, phone: input.customer.phone || '' },
    delivery: input.method === 'ship'
      ? { method: 'ship', address: input.address }
      : { method: 'collect', address: null, instructions: input.note || 'Collect from reception' },
    items,
    subtotal: round2(input.subtotal),
    shipping: round2(input.shipping || 0),
    tax: 0,
    discount: 0,
    total: round2(input.total),
    paymentStatus: 'paid',
    fulfilmentStatus: 'unfulfilled',
    tracking: null,
    customerNote: input.method === 'ship' ? (input.note || '') : '',
    internalNote: '',
    timeline: [{ at: nowIso, label: 'Order placed and paid' }],
  };
  saveOrders([order, ...orders]);
  return order;
};

// ---- product sales (Sales tab) ----------------------------------------------
// Derives a simple sales report from online orders plus a few seeded in-salon
// (POS) product sales, so the Sales tab has both channels to show.
const POS_SALES = [
  { id: 's-pos-1', name: 'Repair Shampoo 250ml', qty: 1, unitPrice: 22, channel: 'pos', soldAt: ts(0, 14, 0), staff: 'Aimee' },
  { id: 's-pos-2', name: 'Argan Hair Oil 100ml', qty: 2, unitPrice: 28, channel: 'pos', soldAt: ts(1, 13, 0), staff: 'Jordan' },
  { id: 's-pos-3', name: 'Sea Salt Texture Spray', qty: 1, unitPrice: 18, channel: 'pos', soldAt: ts(2, 15, 30), staff: 'Aimee' },
  { id: 's-pos-4', name: 'Bond Treatment Mask', qty: 1, unitPrice: 34, channel: 'pos', soldAt: ts(4, 12, 0), staff: 'Priya' },
  { id: 's-pos-5', name: 'Wide-tooth Comb', qty: 3, unitPrice: 9, channel: 'pos', soldAt: ts(6, 16, 0), staff: 'Jordan' },
];

export const getProductSales = () => {
  const orders = getOrders().filter((o) => o.fulfilmentStatus !== 'cancelled');
  const onlineLines = orders.flatMap((o) =>
    (o.items || []).map((it, i) => ({
      id: `${o.id}-${i}`, name: it.name, qty: it.qty, unitPrice: it.unitPrice,
      channel: 'online', soldAt: o.createdAt, customer: o.customer.name, orderId: o.id, orderNumber: o.number,
    }))
  );
  const lines = [...onlineLines, ...POS_SALES].sort((a, b) => (a.soldAt < b.soldAt ? 1 : -1));

  const revenue = lines.reduce((s, l) => s + l.qty * l.unitPrice, 0);
  const units = lines.reduce((s, l) => s + l.qty, 0);
  const onlineRevenue = lines.filter((l) => l.channel === 'online').reduce((s, l) => s + l.qty * l.unitPrice, 0);
  const orderCount = new Set(onlineLines.map((l) => l.orderId)).size;

  // Top products by revenue.
  const byProduct = new Map();
  lines.forEach((l) => {
    const e = byProduct.get(l.name) || { name: l.name, units: 0, revenue: 0 };
    e.units += l.qty; e.revenue += l.qty * l.unitPrice; byProduct.set(l.name, e);
  });
  const topProducts = [...byProduct.values()].sort((a, b) => b.revenue - a.revenue).slice(0, 5);

  return {
    kpis: {
      revenue,
      units,
      onlinePct: revenue ? Math.round((onlineRevenue / revenue) * 100) : 0,
      avgOrder: orderCount ? onlineRevenue / orderCount : 0,
    },
    topProducts,
    recent: lines.slice(0, 12),
  };
};

// ---- product sales lines (Sales tab reporting) -----------------------------
// A deterministic ~12-month dataset (online + in-salon POS) so the Sales tab
// has a populated chart, KPIs, breakdowns and a paginated transactions list —
// mirroring the Vouchers V2 Sales tab. TODO(backend): replace with a real
// product-sales report endpoint (online orders + POS line items).
// `cost` is the wholesale cost to the salon (mock). TODO(backend): real product
// cost is `stockPrice` on the product record. Margin = price - cost.
const CATALOG = [
  { name: 'Repair Shampoo 250ml',   category: 'Haircare',   brand: 'Kerabond',   price: 22, cost: 10 },
  { name: 'Bond Treatment Mask',    category: 'Treatments', brand: 'Kerabond',   price: 34, cost: 15 },
  { name: 'Sea Salt Texture Spray', category: 'Styling',    brand: 'Wavelength', price: 18, cost: 8 },
  { name: 'Argan Hair Oil 100ml',   category: 'Haircare',   brand: 'Maroc',      price: 28, cost: 12 },
  { name: 'Wide-tooth Comb',        category: 'Tools',      brand: 'Salon Pro',  price: 9,  cost: 5 },
  { name: 'Heat Protect Spray',     category: 'Styling',    brand: 'Wavelength', price: 20, cost: 9 },
  { name: 'Scalp Serum',            category: 'Treatments', brand: 'Maroc',      price: 42, cost: 16 },
  { name: 'Detangling Brush',       category: 'Tools',      brand: 'Salon Pro',  price: 16, cost: 9 },
];
const CUSTOMERS = ['Hannah Brooks', 'Marcus Webb', 'Priya Shah', 'Daniel Okafor', 'Sophie Allen', 'Leah Wright', 'Tom Hughes', 'Ava Patel'];
const STAFF = ['Aimee', 'Jordan', 'Priya'];

// Tiny deterministic PRNG (LCG) so the demo dataset is stable across reloads.
const lcg = (seed) => { let s = seed % 2147483647; if (s <= 0) s += 2147483646; return () => (s = (s * 16807) % 2147483647) / 2147483647; };

// A deterministic (seeded), cached year of product sales lines for the slim
// merchandising glance — top sellers + online-vs-in-salon split. The real
// money/commission/transaction reporting lives in the Finance tab.
// opts.staff (real team names) and opts.products (real catalogue) are layered in
// where available; otherwise the sample STAFF/CATALOG are used so it never empties.
let _linesCache = null, _linesKey = null;
export const getProductSalesLines = (opts = {}) => {
  const staffPool = (opts.staff && opts.staff.length) ? opts.staff : STAFF;
  const catalog = (opts.products && opts.products.length) ? opts.products : CATALOG;
  const key = `${staffPool.join('|')}#${catalog.map((c) => c.name).join('|')}`;
  if (_linesCache && _linesKey === key) return _linesCache;
  const refEnd = new Date('2026-06-05T00:00:00Z').getTime();
  const r = lcg(7);
  const lines = [];
  let id = 0;
  for (let monthsAgo = 11; monthsAgo >= 0; monthsAgo--) {
    const n = 9 + Math.floor(r() * 7) + (11 - monthsAgo); // grows toward recent
    for (let k = 0; k < n; k++) {
      const p = catalog[Math.floor(r() * catalog.length)];
      const qty = 1 + Math.floor(r() * 3);
      const channel = r() < 0.55 ? 'online' : 'pos';
      const dayInMonth = Math.floor(r() * 27);
      const soldAt = new Date(refEnd - (monthsAgo * 30 + dayInMonth) * 86400000).toISOString();
      const price = Number(p.price) || 0;
      const cost = (p.cost != null) ? p.cost : Math.round(price * 0.5); // real products lack cost
      lines.push({
        id: `pl-${id++}`, name: p.name, category: p.category || 'Retail', brand: p.brand || '',
        qty, unitPrice: price, cost, paidAmount: qty * price, lineCost: qty * cost, channel, soldAt,
        customer: channel === 'online' ? CUSTOMERS[Math.floor(r() * CUSTOMERS.length)] : null,
        staff: channel === 'pos' ? staffPool[Math.floor(r() * staffPool.length)] : null,
      });
    }
  }
  _linesCache = lines.sort((a, b) => (a.soldAt < b.soldAt ? 1 : -1));
  _linesKey = key;
  return _linesCache;
};

const inRange = (iso, from, to) => {
  const t = new Date(iso).getTime();
  return (!from || t >= from.getTime()) && (!to || t <= to.getTime());
};

export const filterLines = (lines, { from, to, channel, category, brand, product, staff, query } = {}) => {
  const q = (query || '').trim().toLowerCase();
  return lines.filter((l) =>
    inRange(l.soldAt, from, to)
    && (!channel || channel === 'all' || l.channel === channel)
    && (!category || category === 'all' || l.category === category)
    && (!brand || brand === 'all' || l.brand === brand)
    && (!product || product === 'all' || l.name === product)
    && (!staff || staff === 'all' || l.staff === staff)
    && (!q || l.name.toLowerCase().includes(q) || (l.customer || '').toLowerCase().includes(q) || (l.staff || '').toLowerCase().includes(q))
  );
};

export const aggregateLines = (lines, granularity) => {
  const buckets = new Map();
  const keyOf = (d) => {
    if (granularity === 'daily') return d.toISOString().slice(0, 10);
    if (granularity === 'weekly') { const w = new Date(d); w.setDate(d.getDate() - d.getDay()); return w.toISOString().slice(0, 10); }
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  };
  const labelOf = (d) => granularity === 'monthly'
    ? d.toLocaleDateString('en-GB', { month: 'short', year: '2-digit' })
    : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  lines.forEach((l) => {
    const d = new Date(l.soldAt);
    const k = keyOf(d);
    if (!buckets.has(k)) buckets.set(k, { key: k, label: labelOf(d), online: 0, pos: 0, onlineUnits: 0, posUnits: 0, count: 0, _t: d.getTime() });
    const b = buckets.get(k);
    if (l.channel === 'online') { b.online += l.paidAmount; b.onlineUnits += l.qty; }
    else { b.pos += l.paidAmount; b.posUnits += l.qty; }
    b.count += l.qty;
  });
  // total / totalUnits let the chart draw a "total" line over the channel split.
  return [...buckets.values()]
    .sort((a, b) => a._t - b._t)
    .map((b) => ({ ...b, total: b.online + b.pos, totalUnits: b.count }));
};

const pctChange = (cur, was) => (was ? Math.round(((cur - was) / was) * 100) : (cur ? 100 : 0));

export const computeLineKpis = (lines, prev) => {
  const revenue = lines.reduce((s, l) => s + l.paidAmount, 0);
  const units = lines.reduce((s, l) => s + l.qty, 0);
  const onlineRev = lines.filter((l) => l.channel === 'online').reduce((s, l) => s + l.paidAmount, 0);
  return {
    revenue, units,
    onlinePct: revenue ? Math.round((onlineRev / revenue) * 100) : 0,
    avgSale: lines.length ? revenue / lines.length : 0,
    revenueChange: prev ? pctChange(revenue, prev.reduce((s, l) => s + l.paidAmount, 0)) : null,
    unitsChange: prev ? pctChange(units, prev.reduce((s, l) => s + l.qty, 0)) : null,
  };
};

export const lineChannelBreakdown = (lines) => {
  const online = lines.filter((l) => l.channel === 'online').reduce((s, l) => s + l.paidAmount, 0);
  const pos = lines.filter((l) => l.channel === 'pos').reduce((s, l) => s + l.paidAmount, 0);
  const total = online + pos;
  return {
    online: { revenue: online, percent: total ? Math.round((online / total) * 100) : 0 },
    pos: { revenue: pos, percent: total ? Math.round((pos / total) * 100) : 0 },
    total,
  };
};

export const topProductsBy = (lines, n = 5) => {
  const m = new Map();
  lines.forEach((l) => {
    const e = m.get(l.name) || { name: l.name, count: 0, revenue: 0 };
    e.count += l.qty; e.revenue += l.paidAmount; m.set(l.name, e);
  });
  return [...m.values()].sort((a, b) => b.revenue - a.revenue).slice(0, n);
};

export const productCategories = (lines) => Array.from(new Set(lines.map((l) => l.category))).sort();
export const productBrands = (lines) => Array.from(new Set(lines.map((l) => l.brand))).sort();
export const productNames = (lines) => Array.from(new Set(lines.map((l) => l.name))).sort();
export const productStaff = (lines) => Array.from(new Set(lines.map((l) => l.staff).filter(Boolean))).sort();

// Always show 2 decimals (and thousands grouping) — prices read as £x.xx.
export const fmtMoney = (n, currency = '£') => `${currency}${(Number(n) || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
};
export const fmtDateTime = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return `${d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })} · ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`;
};

// ---- product insights (Sales tab) ------------------------------------------
// Actionable, retail-focused insights derived from the (already filtered) sales
// lines. Each generator returns an insight or null; we rank by priority and keep
// the top few — the same shape as the Finance AIInsightsCard. icon ∈ bulb |
// warning | up | down; tone drives the chip colour in ProductSales.
// TODO(backend): a few of these (retail attach rate, stock cover) want real
// appointment / inventory data; today they use sales-only heuristics.
export const computeProductInsights = (lines, currency = '£') => {
  if (!lines || lines.length === 0) return { forecastAmount: 0, percentChange: null, items: [] };

  const revenue = lines.reduce((s, l) => s + l.paidAmount, 0);
  const onlineRev = lines.filter((l) => l.channel === 'online').reduce((s, l) => s + l.paidAmount, 0);
  const onlinePct = revenue ? Math.round((onlineRev / revenue) * 100) : 0;

  const ranked = topProductsBy(lines, 999);
  const best = ranked[0];
  const slow = ranked.length > 2 ? ranked[ranked.length - 1] : null;
  const top3Rev = ranked.slice(0, 3).reduce((s, p) => s + p.revenue, 0);
  const top3Pct = revenue ? Math.round((top3Rev / revenue) * 100) : 0;

  // Category concentration.
  const byCat = new Map();
  lines.forEach((l) => { byCat.set(l.category, (byCat.get(l.category) || 0) + l.paidAmount); });
  const topCat = [...byCat.entries()].sort((a, b) => b[1] - a[1])[0];
  const topCatPct = topCat && revenue ? Math.round((topCat[1] / revenue) * 100) : 0;

  // Forecast: run-rate from the last 3 months' total revenue.
  const monthly = aggregateLines(lines, 'monthly');
  const last3 = monthly.slice(-3);
  const forecastAmount = last3.length ? Math.round(last3.reduce((s, b) => s + b.total, 0) / last3.length) : 0;

  // Period-over-period change: recent half of the months vs the earlier half
  // (by summed revenue), so it tracks the same trend the chart shows.
  let percentChange = null;
  if (monthly.length >= 2) {
    const cut = Math.floor(monthly.length / 2);
    const firstHalf = monthly.slice(0, cut).reduce((s, b) => s + b.total, 0);
    const secondHalf = monthly.slice(cut).reduce((s, b) => s + b.total, 0);
    percentChange = firstHalf ? Math.round(((secondHalf - firstHalf) / firstHalf) * 100) : null;
  }

  const items = [];
  if (best) items.push({
    id: 'best', icon: 'bulb', tone: 'teal', priority: 92,
    lead: `${best.name} is your top seller, with ${best.count} sold (${fmtMoney(best.revenue, currency)}).`,
    action: 'Recommend it at the chair and at checkout to lift retail revenue.',
  });

  if (onlinePct <= 35) items.push({
    id: 'online-low', icon: 'warning', tone: 'amber', priority: 80,
    lead: `Only ${onlinePct}% of product sales happen online.`,
    action: 'Share your online store with clients so they can reorder between appointments.',
  });
  else if (onlinePct >= 60) items.push({
    id: 'online-high', icon: 'up', tone: 'green', priority: 42,
    lead: `Online drives ${onlinePct}% of product revenue.`,
    action: 'Add your top products to booking confirmations so clients can reorder in a tap.',
  });

  if (slow && best && slow.revenue < best.revenue * 0.35) items.push({
    id: 'slow', icon: 'down', tone: 'red', priority: 72,
    lead: `${slow.name} is barely moving, with just ${slow.count} sold this period.`,
    action: `Bundle it with ${best.name}, discount it, or feature it online to clear stock.`,
  });

  if (percentChange != null && percentChange <= -8) items.push({
    id: 'falling', icon: 'down', tone: 'red', priority: 85,
    lead: `Product sales are down ${Math.abs(percentChange)}% across this period.`,
    action: 'Refresh your retail display and prompt the team to recommend take-home products.',
  });
  else if (percentChange != null && percentChange >= 8) items.push({
    id: 'rising', icon: 'up', tone: 'green', priority: 38,
    lead: `Product sales are up ${percentChange}% across this period.`,
    action: 'Keep your best sellers stocked and front of shelf to sustain it.',
  });

  if (top3Pct >= 55 && ranked.length >= 4) items.push({
    id: 'concentration', icon: 'warning', tone: 'amber', priority: 58,
    lead: `Your top 3 products drive ${top3Pct}% of retail revenue.`,
    action: 'Keep them in stock so a sell-out does not dent sales, and grow your hero range over time.',
  });

  if (topCat && topCatPct >= 45) items.push({
    id: 'category', icon: 'bulb', tone: 'blue', priority: 48,
    lead: `${topCat[0]} makes up ${topCatPct}% of product revenue.`,
    action: 'Cross-sell from other categories at checkout to grow the average basket.',
  });

  items.sort((a, b) => b.priority - a.priority);
  return { forecastAmount, percentChange, items: items.slice(0, 3) };
};

// ---- Catalogue Data helpers (retail intelligence) --------------------------
// Behaviour-driving aggregates for the Products > Data tab. Mock-first; the real
// versions live in Finance (sales-by-staff, retail attach). TODO(backend): wire
// the leaderboard + attach to the appointments + checkout ledger.

const hashName = (s = '') => { let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 9973; return h; };

// Who sells the most retail in-salon (the coaching number). POS lines carry the
// stylist who sold them; online has no stylist (that is the shop, see channel split).
export const staffRetailLeaderboard = (lines) => {
  const pos = lines.filter((l) => l.channel === 'pos' && l.staff);
  const m = new Map();
  pos.forEach((l) => {
    const e = m.get(l.staff) || { name: l.staff, revenue: 0, units: 0, top: new Map() };
    e.revenue += l.paidAmount; e.units += l.qty;
    e.top.set(l.name, (e.top.get(l.name) || 0) + l.qty);
    m.set(l.staff, e);
  });
  return [...m.values()].map((e) => {
    let topProduct = null, topQty = 0;
    e.top.forEach((q, name) => { if (q > topQty) { topQty = q; topProduct = name; } });
    const h = hashName(e.name);
    return {
      id: e.name, name: e.name, revenue: e.revenue, units: e.units, topProduct,
      attach: 18 + (h % 17),   // mock attach % (18-34)
      trend: (h % 25) - 8,     // mock trend (-8..+16)
    };
  }).sort((a, b) => b.revenue - a.revenue);
};

// Retail-on-top-of-appointments stats for the hero + tiles. Mock attach rate.
// TODO(backend): real attach = appointments-with-retail / total appointments.
export const attachStats = (lines, attachRate = 28, targetRate = 35) => {
  const pos = lines.filter((l) => l.channel === 'pos');
  const attachedRevenue = pos.reduce((s, l) => s + l.paidAmount, 0);
  const units = pos.reduce((s, l) => s + l.qty, 0);
  const appts = Math.round(pos.length / (attachRate / 100)) || 0;
  const avgRetailPerVisit = pos.length ? attachedRevenue / pos.length : 0;
  const upliftMoney = ((targetRate - attachRate) / 100) * appts * avgRetailPerVisit;
  return { attachRate, targetRate, attachedRevenue, units, appts, avgRetailPerVisit, upliftMoney };
};

// Retail margin from line cost. TODO(backend): cost = stockPrice on the product.
export const productMarginStats = (lines) => {
  const revenue = lines.reduce((s, l) => s + l.paidAmount, 0);
  const cost = lines.reduce((s, l) => s + (l.lineCost || 0), 0);
  const margin = revenue - cost;
  return { revenue, cost, margin, marginPct: revenue ? Math.round((margin / revenue) * 100) : 0 };
};

const richestCategory = (lines) => {
  const m = new Map();
  lines.forEach((l) => { const e = m.get(l.category) || { rev: 0, cost: 0 }; e.rev += l.paidAmount; e.cost += (l.lineCost || 0); m.set(l.category, e); });
  let cat = null, pct = 0;
  m.forEach((e, c) => { const p = e.rev ? (e.rev - e.cost) / e.rev * 100 : 0; if (p > pct) { pct = p; cat = c; } });
  return cat ? { category: cat, marginPct: Math.round(pct) } : null;
};

// Coaching cards in the OpportunityCard shape: { icon, tone, metric, money, advice, cta? }.
export const computeProductOpportunities = (lines, currency = '£') => {
  if (!lines || lines.length === 0) return [];
  const ranked = topProductsBy(lines, 999);
  const best = ranked[0];
  const slow = ranked.length > 2 ? ranked[ranked.length - 1] : null;
  const attach = attachStats(lines);
  const cat = richestCategory(lines);
  const out = [];

  out.push({
    id: 'attach', icon: 'warning', tone: 'amber',
    metric: `${attach.attachRate}% of in-person visits left with a product.`,
    money: `~${fmtMoney(attach.upliftMoney, currency)} if you reach ${attach.targetRate}%`,
    advice: 'Prompt every team member to recommend one take-home product before checkout.',
  });
  if (best) out.push({
    id: 'best', icon: 'bulb', tone: 'teal',
    metric: `${best.name} is your top seller, ${best.count} sold.`,
    money: `${fmtMoney(best.revenue, currency)} this period`,
    advice: 'Feature it in person and on booking confirmations to keep the momentum.',
  });
  if (cat) out.push({
    id: 'margin', icon: 'target', tone: 'green',
    metric: `Your richest margin is in ${cat.category} at ${cat.marginPct}%.`,
    money: 'Best profit per sale',
    advice: `Lead with ${cat.category.toLowerCase()} when you recommend to clients.`,
  });
  if (slow && best && slow.revenue < best.revenue * 0.35) out.push({
    id: 'slow', icon: 'down', tone: 'red',
    metric: `${slow.name} earns the least of your range.`,
    money: `${fmtMoney(slow.revenue, currency)} from ${slow.count} sold`,
    advice: 'Bundle it with a best seller, raise the price, or feature it online to lift its return.',
  });
  return out.slice(0, 4);
};
